import { P2GBox } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { useState } from 'react';
import { Dimensions } from '~/lib/api/smartsend/types';
import ServiceInfo, { ServiceTabType } from '../quotes/ServiceInfo';
import { Tagged } from '../../Tagged';
import { P2GServiceLogo } from '@parcel2go/core-ui';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  service: { Id: string; Provider: string; Name: string; AccountId: string };
  dims: Dimensions;
  senderIsoCode: string | undefined;
  senderSubdivision: string | undefined;
  recipientIsoCode: string | undefined;
  recipientSubdivision: string | undefined;
  label?: string;
  itemId: string;
  currencyCode: string;
}

const ServiceInformationModal: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<ServiceTabType>('INFO');
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (!props.service) {
    return null;
  }

  return (
    <>
      <P2GLink onClick={() => setOpen(true)}>{props.label || t('SERVICE_INFO_LINK', { defaultValue: 'Why?' })}</P2GLink>
      <P2GSidePanel
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={props.service.Name || t('SERVICE_INFO_SIDEPANEL_TITLE', { defaultValue: 'Service Info' })}
        preTitle={
          props.service.Id && (
            <div style={{ width: '150px' }}>
              <P2GBox p={1} bordered>
                <P2GServiceLogo size="normal-svg" slug={props.service.Id} />
              </P2GBox>
            </div>
          )
        }
      >
        <Tagged tag="panel-service-information">
          <ServiceInfo
            setTab={setTab}
            tab={tab}
            key={`${props.service.Id}_${props.service.Provider}_${props.service.AccountId}`}
            id={props.service.Id}
            itemId={props.itemId}
            provider={props.service.Provider}
            accountId={props.service.AccountId}
            comparison={props.dims}
            senderIsoCode={props.senderIsoCode}
            senderSubdivision={props.senderSubdivision}
            recipientIsoCode={props.recipientIsoCode}
            recipientSubdivision={props.recipientSubdivision}
            currencyCode={props.currencyCode}
          />
        </Tagged>
      </P2GSidePanel>
    </>
  );
};
export default ServiceInformationModal;
